import React from 'react';
import { styled } from '@mui/system';
import { useSelector } from 'react-redux';
import { capitalize, getStringProduct } from '../../../utils/utilityFunctions';
import { appInsights } from '../../../auth/appInsight';

export const Title = styled('div')(({ theme, fontweight }) => ({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: fontweight || '500',
  fontSize: '32px',
  lineHeight: '48px',
  color: theme.palette.primary.onBoardTextColor,
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: '24px',
    lineHeight: '36px'
  },
  [theme.breakpoints.up('xll')]: {
    fontSize: getStringProduct(1.25, '32px'),
    lineHeight: getStringProduct(1.25, '48px')
  },
  [theme.breakpoints.up('xlll')]: {
    fontSize: getStringProduct(1.66, '32px'),
    lineHeight: getStringProduct(1.66, '48px')
  },
  [theme.breakpoints.up('xl4')]: {
    fontSize: getStringProduct(2.46, '32px'),
    lineHeight: getStringProduct(2.46, '48px')
  }
}));
export const Para = styled('p')(({ theme, fontsize, smfontsize, smlineHeight, xlfontsize, lineheight, xllineHeight, textalign, fontweight, color, padding360, marginbottom, textalignsm }) => ({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: fontweight || 400,
  fontSize: fontsize || '18px',
  lineHeight: lineheight || '27px',
  textAlign: textalign || 'center',
  marginBottom: marginbottom,
  color: color || theme.palette.primary.onBoardTextColor,
  opacity: '0.9',
  [theme.breakpoints.down('sm')]: {
    fontSize: smfontsize || '12px',
    lineHeight: smlineHeight || '18px',
    padding: padding360 || '20px',
    textAlign: textalignsm || 'justify'
  },
  [theme.breakpoints.up('xll')]: {
    fontSize: getStringProduct(1.25, fontsize || '18px'),
    lineHeight: getStringProduct(1.25, lineheight || '27px'),
    marginBottom: getStringProduct(1.25, marginbottom || '')
  },
  [theme.breakpoints.up('xlll')]: {
    fontSize: getStringProduct(1.66, fontsize || '18px'),
    lineHeight: getStringProduct(1.66, lineheight || '27px'),
    marginBottom: getStringProduct(1.66, marginbottom || '')
  },
  [theme.breakpoints.up('xl4')]: {
    fontSize: getStringProduct(2.46, fontsize || '18px'),
    lineHeight: getStringProduct(2.46, lineheight || '27px'),
    marginBottom: getStringProduct(2.46, marginbottom || '')
  }
}));

export const UserName = () => {
  const userName = useSelector((state) => state.user.fullName);
  try {
    return <Title>Hello {capitalize(userName)}!</Title>;
  } catch (error) {
    appInsights.trackException({ error: new Error(error) });
  }
};

export const FreedomViewAllText = styled('h4')(({ theme }) => ({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '12px',
  lineHeight: '18px',
  cursor: 'pointer',
  color: theme.palette.primary,

  [theme.breakpoints.up('xll')]: {
    fontSize: getStringProduct(1.25, '12px'),
    lineHeight: getStringProduct(1.25, '18px')
  },
  [theme.breakpoints.up('xlll')]: {
    fontSize: getStringProduct(1.66, '12px'),
    lineHeight: getStringProduct(1.66, '18px')
  },
  [theme.breakpoints.up('xl4')]: {
    fontSize: getStringProduct(2.46, '12px'),
    lineHeight: getStringProduct(2.46, '18px')
  }
}));
